import { type TProductTypeQuery, useProductTypeQuery } from "@/3514/queries"
import { buildCssClassName, withPressHandler } from "@/3514/utils"
import { type IUseTranslation, useTranslation } from "@/hooks"
import { WiserLogo } from "@/svgs"

import { type TEmptyCallback, emptyCallback } from "./types/functions"

type Props = {
    className?: string
    width?: number
    heigth?: number
    handleLogoClick?: TEmptyCallback
}

const ProductTypeLogo = ({ className, heigth = 34, width = 26, handleLogoClick = emptyCallback }: Props) => {
    const { data: productType }: TProductTypeQuery = useProductTypeQuery()

    const { t }: IUseTranslation = useTranslation()

    return (
        <div
            className={buildCssClassName("cursor-pointer", { [className]: className })}
            onClick={withPressHandler(handleLogoClick)}
            onKeyDown={withPressHandler(handleLogoClick)}
        >
            {productType?.logo ? (
                <img src={productType?.logo} width={width} height={heigth} alt={t("Wiser logo")} />
            ) : (
                <WiserLogo width={width} height={heigth} />
            )}
        </div>
    )
}

export default ProductTypeLogo
